import { Route } from '@angular/router';
import { ContentSplitViewLayoutWideComponent } from '@kempower-nx-workspace/layout-templates';

import { ProductUpdatesComponent } from './feature/product-update/product-updates.component';
import { ProductUpdateMenuComponent } from './feature/product-update-menu/product-update-menu.component';
import { chargEyeTitle } from '@kempower-nx-workspace/chargeye-shared';

export const helpRoutes: Route[] = [
    {
        path: '',
        redirectTo: '/help/product-updates/chargeye',
        pathMatch: 'full',
    },
    {
        path: ':productUpdateType',
        component: ContentSplitViewLayoutWideComponent,
        children: [
            {
                path: '',
                outlet: 'splitViewMenu',
                component: ProductUpdateMenuComponent,
            },
            {
                path: ':productUpdateId',
                component: ProductUpdatesComponent,
                title: `Product updates ${chargEyeTitle}`,
            },
        ],
    },
];
